import { createVanIconComponent } from "./van"

const Upgrade = createVanIconComponent("upgrade")
export default Upgrade
